import React, { useContext } from 'react';
import Breadcrumb from '@prisjakt/ui-breadcrumb';
import { AppContext } from '@prisjakt/ui-app-context';
import { Product, CategoryPath } from '../../../../types';
import { BreadCrumbWrapper } from './styles';

const ProductBreadCrumb: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IProductBreadCrumbProps>
>> = props => {
  const { product } = props;
  const { t } = useContext(AppContext);
  return (
    <BreadCrumbWrapper>
      <Breadcrumb
        homeText={t('common', 'breadcrumb.home')}
        path={
          product.category?.path
            ? (product.category.path.filter(x => x) as CategoryPath[])
            : []
        }
        firstPathSelectable
      />
    </BreadCrumbWrapper>
  );
};

interface IProductBreadCrumbProps {
  product: Product;
}

export default ProductBreadCrumb;
